import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Problem() {
  const {
    t
  } = useLanguage();
  const painPoints = t.problem.points;
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet relative overflow-hidden" data-id="element-212">
      <div className="gold-spotlight-top" aria-hidden="true" data-id="element-213" />
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-214">
        <div className="max-w-4xl mx-auto" data-id="element-215">
          <SectionHeading title={`${t.problem.title1}<span class='font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle mx-1'>${t.problem.titleHighlight}</span>${t.problem.title2}`} subtitle={t.problem.subtitle} data-id="element-216" />

          <div className="space-y-6 font-sans text-lg text-riam-gold-light/80 leading-relaxed mb-12" data-id="element-217">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-218">
              {t.problem.p1}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-219">
              {t.problem.p2}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-220">
              {t.problem.p3}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-221">
              {t.problem.p4}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-script font-semibold italic md:text-3xl text-riam-gold py-2 text-[25px]" data-id="element-222">
              {t.problem.p5}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-223">
              {t.problem.p6}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-224">
              {t.problem.p7}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-225">
              {t.problem.p8}
            </motion.p>
          </div>

          <div className="grid gap-4 mb-12" data-id="element-226">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="gold-border-hover flex items-start space-x-4 p-4 rounded-sm bg-riam-dark/50" data-id="element-227">
                <AlertCircle className="icon-glow flex-shrink-0 mt-1" size={24} stroke="url(#riamGold)" data-id="element-228" />
                <p className="font-sans text-riam-gold-light text-lg" data-id="element-229">
                  {point}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-16" data-id="element-230">
            <p className="font-script font-semibold text-3xl md:text-4xl text-riam-gold mb-4" data-id="element-231">
              {t.problem.conclusion1}
            </p>
            <p className="font-sans text-lg md:text-xl text-riam-gold-light/90 font-medium" data-id="element-232">
              {t.problem.conclusion2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}